<ng-container *transloco="let t;">

  <div class="card p-mb-4" [ngClass]="{'card-disabled': disabled === true }">
    <div class="p-grid">
      <div class="p-col-6">
        <h2>{{ t('common.labels.candidate') }}</h2>
      </div>
      <div class="p-col-6 p-text-right">
        <button type="button" pButton [label]="t('partials.employee_search.topline')" icon="pi pi-search" (click)="onOpenEmployeeSearch()" [disabled]="disabled" class="p-button-sm p-button-secondary p-button-outlined"></button>
      </div>
    </div>

    <p [innerHtml]="texts.orderform_candidate_before"></p>

    <div class="p-grid">
      <div class="p-col-4">
        <app-form-control [cid]="'gender'" [control]="form.get('candidate.gender')" [type]="'select'" [options]="optionsSalutations" [label]="t('common.labels.gender')"></app-form-control>
      </div>
      <div class="p-col-4">
        <app-form-control [cid]="'firstname'" [control]="form.get('candidate.firstname')" [type]="'input'" [label]="t('common.labels.firstname')"></app-form-control>
      </div>
      <div class="p-col-4">
        <app-form-control [cid]="'lastname'" [control]="form.get('candidate.lastname')" [type]="'input'" [label]="t('common.labels.lastname')"></app-form-control>
      </div>
      <div class="p-col-4">
        <app-form-control [cid]="'email'" [control]="form.get('candidate.email')" [type]="'input'" [label]="t('common.labels.email')"></app-form-control>
      </div>
      <div class="p-col-4">
        <app-form-control [cid]="'phone'" [control]="form.get('candidate.phone')" [type]="'input'" [label]="t('common.labels.phone')"></app-form-control>
      </div>
      <div class="p-col-4">
        <app-form-control [cid]="'mobile'" [control]="form.get('candidate.mobile')" [type]="'input'" [label]="t('common.labels.mobile')"></app-form-control>
      </div>
      <div class="p-col-4">
        <app-form-control [cid]="'corporation'" [control]="form.get('candidate.corporation')" [type]="'select'" [options]="optionsCorporations" [label]="t('common.labels.corporation')"></app-form-control>
      </div>
      <div class="p-col-4">
        <app-form-control [cid]="'language'" [control]="form.get('candidate.language')" [type]="'input'" [label]="t('common.labels.native_language')"></app-form-control>
      </div>
      <div class="p-col-4">
        <app-form-control [cid]="'function'" [control]="form.get('candidate.function')" [type]="'input'" [label]="t('common.labels.actual_function')"></app-form-control>
      </div>
      <div class="p-col-4" *ngIf="boardDivisionVisible === true">
        <app-form-control [cid]="'board_division'" [control]="form.get('candidate.board_division')" [type]="'select'" [options]="options?.board_divisions" [label]="t('common.labels.board_division')"></app-form-control>
      </div>
    </div>

    <p [innerHtml]="texts.orderform_candidate_after"></p>
    <div class="disabled-screen"><i class="pi pi-lock"></i></div>
  </div>

  <app-employee-search #employeesearch (select)="onSelectEmployee($event)"></app-employee-search>


</ng-container>
